import { render } from "./StatsCard.vue?vue&type=template&id=01e9f8cb"
import script from "./StatsCard.vue?vue&type=script&lang=js"
export * from "./StatsCard.vue?vue&type=script&lang=js"

import "./StatsCard.vue?vue&type=style&index=0&id=01e9f8cb&lang=css"
script.render = render

export default script